<app-fordjupning-karta-base [layerConfig]="layerConfig$ | async" (mapClicked)="onMapClicked($event)">
    <app-fordjupning-karta-popup [isLoading]="isLoadingPopupData" [popupContent]="popupData$ | async">
        <ng-container *ngIf="(popupData$ | async)?.thumbsUp; else elseTemplate" popupIcon>
            <span class="abinicon-tall_mellanmark_uppfyllt" role="img" aria-label="Målet är uppnått"></span>
        </ng-container>
        <ng-template #elseTemplate popupIcon>
            <span class="abinicon-tall_mellanmark_ej_uppfyllt" role="img" aria-label="Målet är inte uppnått"></span>
        </ng-template>
    </app-fordjupning-karta-popup>
</app-fordjupning-karta-base>
